/* Envío y plazo visibles en el carrito para México (ganador S5-02).
   Solo actúa con el mercado en pesos. Importe = envío en EUR × tipo de cambio del mercado.
   Se recalcula cada vez que el cajón se vuelve a pintar. */
(function () {
  var cfg = (document.currentScript && document.currentScript.dataset) || {};
  var cur = (window.Shopify && Shopify.currency) || {};
  if (cur.active !== 'MXN') return;
  var rate = parseFloat(cur.rate) || 1;
  var shipEur = parseFloat(cfg.shipEur) || 10.2;
  var days = cfg.days || '9-12 días hábiles';

  function fmt(v) {
    return new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN', currencyDisplay: 'code', maximumFractionDigits: 0 })
      .format(v).replace(/\u00a0/g, ' ');
  }

  var busy = false;
  function render() {
    var form = document.querySelector('.gudslip-cart-drawer__checkout-form');
    if (busy || !form) return;
    busy = true;
    fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
      var prog = document.querySelector('[data-cd-progress]');
      var thr = (prog ? parseFloat(prog.getAttribute('data-h1')) / 100 : 55) * rate;
      var total = c.total_price / 100;
      var html = '';
      if (c.item_count) {
        var row = function (right, cls) { return '<div class="ig-mx-ship__row"><span>Envío a México</span>' + right + '</div>'; };
        html = total >= thr
          ? row('<span class="ig-mx-ship__free">Gratis</span>') + '<div class="ig-mx-ship__note">Entrega estimada: ' + days + '</div>'
          : row('<strong>' + fmt(shipEur * rate) + '</strong>') + '<div class="ig-mx-ship__note">Entrega estimada: ' + days + '. Te faltan ' + fmt(thr - total) + ' para el envío gratis.</div>';
      }
      var el = document.querySelector('.ig-mx-ship');
      if (!html) { if (el) el.remove(); return; }
      if (!el) {
        el = document.createElement('div');
        el.className = 'ig-mx-ship';
        form.parentNode.insertBefore(el, form);
      }
      if (el.innerHTML !== html) el.innerHTML = html;
    }).catch(function () {}).then(function () { busy = false; });
  }

  var t = null;
  new MutationObserver(function () { clearTimeout(t); t = setTimeout(render, 150); }).observe(document.body, { childList: true, subtree: true });
  render();
})();
